import { Component, OnInit} from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Payment } from 'app/shared/types/payment';
import { ActivatedRoute} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { CompanyProfileService } from 'app/shared/services/company-profile.service';
import { PaymentService } from 'app/shared/services/payment.service';
import { BankAccountsService} from 'app/shared/services/bank-accounts.service';
import { PurchaseInvoiceService } from 'app/shared/services/purchase-invoice.service';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { SupplierService} from 'app/shared/services/supplier.service';
import { AuthService } from 'app/shared/services/auth.service';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { map, startWith} from 'rxjs/operators';
import { Observable} from 'rxjs';
import { NbThemeService } from '@nebular/theme';
import { DecimalPipe } from '@angular/common';
import * as moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;



@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();

  isDark: boolean = false;

  supplierList : any[];
  filteredOptions: Observable<any[]>;
  bankAccountList : any[];
  invoiceList : any[];
  unpaidinvoiceList : any[];

  payment:Payment;
  paymentData = [];
  updatePaymentData = [];
  paymentForm: FormGroup;
  isfieldReadOnly : boolean= true;
  isShowAttachBtn: boolean=false;
  isBtnDisabled : boolean= false;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;
  panelTitle ="Payment";
  companyData : any  = [];
  logo :any;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
 

  PMT_TYPE =[
    {value: 'Cash'},
    {value: 'Cheque'},
    {value: 'Card Payment'},
    {value: 'Bank Transfer'},

  ];


  validationMessages = {
    'voucherNo': { 'required': 'Voucher number is required' },
    'paidDate': { 'required': 'Payment date is required' }, 
    'paymentType': { 'required': 'Payment Type  is required' },
    'supId': { 'required': 'Supplier Id  is required' },  
    'supName': {'required': 'Supplier is required' },
    'address': {'required': 'Address is required' },
    'paymentAccount': {'required': 'Payment Accountis required' },
  };

  formErrors = {
    'voucherNo': "",
    'paidDate': "",
    'paymentType' : "",
    'supId' : "",
    'supName': "",
    'address': "",
    'paymentAccount': "",
  };


  constructor(private fb: FormBuilder,
        private paymentService: PaymentService,
        private purchaseInvoiceService : PurchaseInvoiceService,
        private authService: AuthService,
        private toastr: ToastrService,
        private dialogService: DialogService,
        private route : ActivatedRoute,
        private supplierService : SupplierService,
        private fileUploadService:FileUploadService,
        private decimalPipe: DecimalPipe,
        private companyProfileService: CompanyProfileService,
        private router : Router, 
        private themeService: NbThemeService,
        private bankAccountsService: BankAccountsService)
      {
        this.datepickerConfig = Object.assign({},
          {   
            showWeekNumbers:false,
            dateInputFormat : 'YYYY-MM-DD'
          });

      }


    ngOnInit(): void {

      this.initPaymentType();
      this.initFormFields();
      this.getControlPermissions();
      this.getCompanyDetails();
        this.isBtnDisabled = true;    
        this.getSupplierList();
        this.viewPaymentById();
        this.getBankAccountList();
        this.getAllGRN();
        this.disableForm();
        this.viewGRNById();
        this.autoComplete();
  
        this.paymentForm.valueChanges.subscribe((data) => {
          this.logValidationErrors(this.paymentForm);
          });

          this.themeService.onThemeChange()
          .subscribe(themeName =>{
               this.isDark  = themeName.name ==='dark' ? true : false;
             });
       
    }// end oninit


    loadLogo(){
    
      if(this.companyData.length===1){
        if(this.companyData[0].Logo){
          let TYPED_ARRAY = new Uint8Array(this.companyData[0].Logo.data);
          const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
            return data + String.fromCharCode(byte);
          },'');
          let base64String = btoa(STRING_CHAR);
          this.logo = 'data:image/jpeg;base64,' + base64String;
         }else{
          this.logo =null;
         }
    
         if(this.companyData[0].DigitalSignature){
          let TYPED_ARRAY = new Uint8Array(this.companyData[0].DigitalSignature.data);
          const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
            return data + String.fromCharCode(byte);
          },'');
          let base64String = btoa(STRING_CHAR);
          //this.signature = 'data:image/jpeg;base64,' + base64String;
         }else{
          //this.signature =null;
         }
  
      } 
    
     
    }
  
    getCompanyDetails(){
  
      this.companyProfileService.getCompanyDetails()
      .subscribe(
        (data) =>{
  
                  this.companyData = data;   
                  this.loadLogo();         
  
                  },
        (err) => {
          if(err instanceof HttpErrorResponse){                 
            if(err.status == 401){
              this.router.navigate(['/login']);
            }
          }
          console.log(err);
        }
      );
    
    }
    

    getControlPermissions(){
      var data = [];
       data =  this.authService.controlPermissionArray.filter((el)=>{
        return el.moduleCode ==='PMT'
      });
      if(data.length > 0){
        this.crud_access.read = data[0].read;
        this.crud_access.create = data[0].create;
        this.crud_access.approve = data[0].approve;
        this.crud_access.delete = data[0].delete;
      }
    }



    getSupplierList(){
      this.supplierService.getAll()
       .subscribe(
          (data) => {  
                    this.supplierList = data.filter((el)=>{
                      return el.Status !=="Deactivated";
                    });               
                    },
         (err) => 
                  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  });  
         
       }

       autoComplete(){
        this.filteredOptions = this.paymentForm.get('supName').valueChanges
        .pipe(
         startWith(''),
         map(value => this._filter(value))
        );
      
      
      }
      
      
      private _filter(supName: string): any[] {
        if(supName){
           const filterValue = supName.toLowerCase();
           return this.supplierList.filter(option => option.SupName.toLowerCase().indexOf(filterValue) === 0);
        }
      }

      getSupplierDetails(){      
        var filteredData;
        var supName = this.paymentForm.value.supName;
        if(supName){
        filteredData = this.supplierList.filter(data =>data.SupName.toLowerCase()===supName.toLowerCase());
         if(filteredData.length ===1){
           this.paymentForm.patchValue({
             supId : filteredData[0].SupId,
             address :filteredData[0].Address,
           });
         }else{
          this.paymentForm.patchValue({
            supId : null,
            address :null,
          });

         }
        }
     }
      

       getBankAccountList(){
        this.bankAccountsService.getAllBankAccounts()
         .subscribe(
            (data) => {  
                      this.bankAccountList = data             
                      },
           (err) => 
                    {
                      if(err instanceof HttpErrorResponse){                 
                        if(err.status == 401){
                          this.router.navigate(['/login']);
                        }
                      }
                      console.log(err);
                    });  
           
         }


   

    getAllGRN(){
      this.purchaseInvoiceService.getAll()
       .subscribe(
          (data) => {
                    this.invoiceList = data;             
                    },
         (err) => 
                  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  });  
         
       }


      getOutstandingInvoices(supId, myArray){
        this.unpaidinvoiceList = [];
        for (let i=0; i < myArray.length; i++) {
          if (myArray[i].SupId === supId && (myArray[i].Status === 'Unpaid' || myArray[i].Status === 'Partially paid')) {
            this.unpaidinvoiceList.push(myArray[i]);
          }         
        }
        return this.unpaidinvoiceList;
      }
      
 

  initPaymentType() : void{

    this.payment = {
      voucherNo: '',
      paidDate: '',
      paymentType: '',
      supId: '',
      supName: '',
      address: '',  
      paymentAccount:'',
      payRefNo: '',
      paidTotal: 0.00,
      grnDate: '',
      grnNo: '',
      invoiceTotal: 0.00,
      balToPay: 0.00,
      accBalToPay : 0.00,
      amountPaid: 0.00,
      accAmountPaid : 0.00,     
      status : '',
      createdBy : '',
    };
  }

  initFormFields() : void{
    this.paymentForm = this.fb.group({
      voucherNo : ['',Validators.required],
      paidDate : ['',Validators.required],
      paymentType : [null,Validators.required],
      supId : ['',Validators.required],
      supName : [null,Validators.required],
      address : ['',Validators.required],
      paymentAccount : [null,Validators.required],
      payRefNo : [''],
      paidTotal : [''],
      unpaidInvoices : this.fb.array([]), 
       
    });


  }


  newButtonClick(): void {
    this.isfieldReadOnly  = false;
    this.isBtnDisabled = false;
    this.isShowAttachBtn=false;
    this.paymentForm.reset();
    this.getUnpaidInvoices.clear();
    this.enableForm();
    this.getMaxId();
    this.paymentForm.patchValue({
      paidDate:  this.defaultDate
    });
     
   }

   getMaxId(){
    var voucherNo = 0;
    var voucherNoPrefixZero  : String;
  
    this.paymentService.getMaxId()
    .subscribe(
      (res) => {
          voucherNo = Number(res[0].VoucherNo) + 1;
          voucherNoPrefixZero = voucherNo.toString().padStart(6,'0');       
          this.paymentForm.patchValue({
            voucherNo : "SPMT" + voucherNoPrefixZero
          });
         
      },        
      (err) =>  {
                if(err instanceof HttpErrorResponse){                 
                  if(err.status == 401){
                    this.router.navigate(['/login']);
                  }
                }
                console.log(err);
                }, 
      )

   }
  
   loadUnpaidInvoices(data) :FormArray{   
      const unpaidInvoiceArray = new FormArray([]);
      for(let i =0; i < data.length;i++){ 
        unpaidInvoiceArray.push(this.fb.group({
          grnDate : [moment(data[i].GrnDate).format("YYYY-MM-DD")],
          grnNo : [data[i].GrnNo],
          invoiceTotal : [data[i].GrandTotal],
          balToPay : [data[i].BalToPay],
          accAmountPaid : [data[i].AmountPaid],
          amountPaid : [],
          select : [false],    
        }));
      }
      return unpaidInvoiceArray;
      
   }

    selectInvoiceCheckBoxChange(event,i){
      if(event.checked){
        var value = this.getUnpaidInvoices.value[i].balToPay
        this.getUnpaidInvoices.at(i).patchValue({amountPaid : value})
      }
      else{
        this.getUnpaidInvoices.at(i).patchValue({amountPaid : ''})
      }

      this.updatePaymentTotal();

    }

   get getUnpaidInvoices(){
      return this.paymentForm.get('unpaidInvoices') as FormArray;
   }

   loadInvoiceButtonClick() : void {
    this.getUnpaidInvoices.clear();
    var supId = this.paymentForm.value.supId
      if(supId){
       var data= this.getOutstandingInvoices(supId, this.invoiceList);
          if(data.length > 0){
              this.paymentForm.setControl('unpaidInvoices',this.loadUnpaidInvoices(data));           
          }else{
            this.toastr.warning('No outstanding invoices for this supplier.','Warning');
          }
      }else{
        this.toastr.warning('Supplier Not Selected.','Warning');
      }

  }

    removeItemButtonClick(itemIndex : number) : void{
      this.getUnpaidInvoices.removeAt(itemIndex);
      this.updatePaymentTotal()
    }


    updatePaymentTotal(){
        var totalAmount = this.getUnpaidInvoices.value.reduce((prev,curr)=>prev + +curr.amountPaid, 0);
        this.paymentForm.patchValue({
          paidTotal : totalAmount
        });
     }


  mapFormValuesToModel(){
    this.paymentData =[];
    this.updatePaymentData =[];
    var result = [];
    var updateResult = [];

    for(let i=0; i < this.getUnpaidInvoices.length; i++){

      var isChecked =this.getUnpaidInvoices.value[i].select;

      if(isChecked){

        this.payment.voucherNo=this.paymentForm.value.voucherNo;
        this.payment.paidDate=this.paymentForm.value.paidDate;
        this.payment.paymentType=this.paymentForm.value.paymentType;
        this.payment.supId=this.paymentForm.value.supId;
        this.payment.supName=this.paymentForm.value.supName;
        this.payment.address = this.paymentForm.value.address;
        this.payment.paymentAccount=this.paymentForm.value.paymentAccount;
        this.payment.payRefNo=this.paymentForm.value.payRefNo;
        this.payment.paidTotal = this.paymentForm.value.paidTotal;
       
        this.payment.grnDate=this.getUnpaidInvoices.value[i].grnDate;
        this.payment.grnNo=this.getUnpaidInvoices.value[i].grnNo;
        this.payment.invoiceTotal=this.getUnpaidInvoices.value[i].invoiceTotal;       
        this.payment.balToPay=this.getUnpaidInvoices.value[i].balToPay;         
        this.payment.amountPaid=this.getUnpaidInvoices.value[i].amountPaid;
        this.payment.accBalToPay= this.payment.balToPay -  this.payment.amountPaid;
        this.payment.accAmountPaid = +this.getUnpaidInvoices.value[i].accAmountPaid + +this.payment.amountPaid;
        this.payment.createdBy =this.authService.getUserLoggedIn();

            if (this.payment.balToPay == this.payment.amountPaid)
            {
              this.payment.status = "Paid";
            }
            else if (this.payment.balToPay > this.payment.amountPaid)
            {
              this.payment.status = "Partially paid";
            }
            else
            {
              this.payment.status = "Unpaid";
            }
    
        
        this.paymentData.push(
              this.payment.voucherNo,
              this.payment.paidDate,
              this.payment.paymentType,
              this.payment.supId,
              this.payment.supName,
              this.payment.address,
              this.payment.paymentAccount,
              this.payment.payRefNo,
              this.payment.paidTotal,
              this.payment.grnDate,
              this.payment.grnNo,
              this.payment.invoiceTotal,
              this.payment.balToPay,
              this.payment.amountPaid,
              this.payment.status,
              this.payment.createdBy,       
          );

          this.updatePaymentData.push(
            this.payment.accBalToPay,
            this.payment.accAmountPaid,
            this.payment.status,
            this.payment.grnNo,
            this.payment.supId,
          );

        } //////// end if

    }  /////// end loop

    while(this.paymentData.length){
      result.push(this.paymentData.splice(0,16));
      updateResult.push(this.updatePaymentData.splice(0,5));
    }

    return [result,updateResult];

  }

  getBalToPayAndAmountPaid(grnNo,supId, myArray){
    for (let i=0; i < myArray.length; i++) {
      if (myArray[i].GrnNo === grnNo && myArray[i].SupId === supId) {
       return myArray[i];
      } 

    }

  }

  mapCancelPaymentDataToModel(){
    var cumBalToPay = 0;
    var cumSmountPaid = 0;
    
    this.updatePaymentData =[];
    var updateResult = [];
    

    for(let i=0; i < this.getUnpaidInvoices.length; i++){

      if(this.getUnpaidInvoices.length > 0){

       this.payment.supId=this.paymentForm.value.supId;
        this.payment.grnNo=this.getUnpaidInvoices.value[i].grnNo;  
        this.payment.invoiceTotal=this.getUnpaidInvoices.value[i].invoiceTotal; 
       
        const getBal= this.getBalToPayAndAmountPaid(this.payment.grnNo,this.payment.supId, this.invoiceList);
         cumBalToPay  = getBal.BalToPay;
         cumSmountPaid = getBal.AmountPaid;

         this.payment.balToPay= +cumBalToPay + +this.getUnpaidInvoices.value[i].amountPaid;        
         this.payment.amountPaid= +cumSmountPaid - +this.getUnpaidInvoices.value[i].amountPaid;


        if (this.payment.invoiceTotal == this.payment.balToPay)
        {
            this.payment.status = "Unpaid";     
        }
        else if(this.payment.invoiceTotal > this.payment.balToPay)
        {
          this.payment.status = "Partially paid";
        }

          this.updatePaymentData.push(
            this.payment.balToPay,
            this.payment.amountPaid,
            this.payment.status,
            this.payment.grnNo,
            this.payment.supId,
          );

        } //////// end if

    }  /////// end loop


    while(this.updatePaymentData.length){
      updateResult.push(this.updatePaymentData.splice(0,5));
     
    }

    return updateResult;

  }
  saveButtonClick(): void {
    this.logValidationErrors(this.paymentForm,true);
    const [data,updateData] = this.mapFormValuesToModel();

    const body = {dataInput : data, updateInput : updateData}
    if(this.isFilledFromFields()){
        this.showProcessingIndicator = true;
          this.paymentService.addPayment(body)
          .subscribe(
            (res) =>{

              if(res.success === 0){
                this.paymentForm.patchValue({
                voucherNo : res.autoId
                });
              this.saveButtonClick();
              this.showProcessingIndicator = false; 
              
              }else if(res.success === 1){
                this.toastr.success('Payment processed successfully','Success');
                console.log(res);
                this.isfieldReadOnly  = true;
                this.isBtnDisabled = true;
                this.isShowAttachBtn = true;
                this.disableForm(); 
                this.showProcessingIndicator = false;  
                this.getAllGRN();   
             }   
                    
            },
            (err) =>{
              console.log(err);
              this.toastr.error('Failed to proceed payment','Failure'); 
              this.showProcessingIndicator = false; 
              this.getAllGRN();   
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            }
          );
        } 

    else{
          this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
          this.showProcessingIndicator = false;   
          this.getAllGRN();                                                                                                                                                                                                  
        }

      
   }

   deleteButtonClick(){
    var voucherNo = this.paymentForm.get('voucherNo').value;
    if(voucherNo){
    this.dialogService.openConfirmDialog('Are you sure you want to cancel this payment?')
    .afterClosed().subscribe(res =>{
      if(res){
    const data = this.mapCancelPaymentDataToModel();
    this.paymentService.deletePayment(data,voucherNo)
    .subscribe(
      (res) => {
                  if(res) {
                    this.toastr.success('Payment canceled successfully','Success');
                    this.newButtonClick();
                    console.log(res); 
                    this.getAllGRN();                         
                    }
                    else{
                      this.toastr.error('Failed to cancel payment','Failure');
                      this.getAllGRN();                       
                    }                  
                },        
      (err) =>  {
                  this.toastr.error('Failed to cancel payment','Failure');
                  console.log(err);
                  this.getAllGRN();    
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                }, 
        );
     } 
   });

  }
 
}


   enableForm():void{
    Object.keys(this.paymentForm.controls).forEach(key => {
      this.paymentForm.controls[key].enable();
      //console.log("Enable "+key)     
    });

  }


  disableForm():void{
    Object.keys(this.paymentForm.controls).forEach(key => {
      this.paymentForm.controls[key].disable();
     // console.log("disable "+key);
    });

  }
  
  logValidationErrors(group: FormGroup = this.paymentForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.paymentForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }

  isFilledFromFields() : boolean {
    var value = this.paymentForm.value.supId;
    if(!value){
      this.paymentForm.patchValue({ supId :  null,supName :  null, address : null });   
      this.getUnpaidInvoices.clear(); 
    }
    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }

        if(this.getUnpaidInvoices.length==0){
          return false;
          }

        return true;
  }

 



    viewPaymentById(){
        var hasVoucherNo;
        var voucherNo;

        hasVoucherNo =this.route.snapshot.queryParamMap.has('voucherNo');
         
          if(hasVoucherNo){
            voucherNo = this.route.snapshot.queryParamMap.get('voucherNo')
            this.paymentService.getPayment(voucherNo)
            .subscribe(
              (data) => {
                        if(data){
                          this.patchValuesToForm(data); 
                          this.disableForm(); 
                          this.isfieldReadOnly = true;
                          this.isShowAttachBtn = true;
                          this.isBtnDisabled = true;                    
                         }
                        },
            (err) => 
                      {
                        if(err instanceof HttpErrorResponse){                 
                          if(err.status == 401){
                            this.router.navigate(['/login']);
                          }
                        }
                        console.log(err);
                      });
      }

    }

patchValuesToForm(data){

  this.paymentForm.patchValue({  

    voucherNo : data[0].VoucherNo,
    paidDate : moment(data[0].PaidDate).format("YYYY-MM-DD"),
    paymentType : data[0].PaymentType,
    supId : data[0].SupId,
    supName : data[0].SupName,
    address : data[0].Address,
    paymentAccount : data[0].PaymentAccount,
    payRefNo : data[0].PayRefNo,
    paidTotal: data[0].PaidTotal,

  });
  
   this.paymentForm.setControl('unpaidInvoices',this.setPaidInvoices(data));


}


  setPaidInvoices(data) : FormArray{
    const paidInvoiceArray = new FormArray([]);
    for(let i =0; i < data.length;i++){ 
      paidInvoiceArray.push(this.fb.group({
        grnDate : [moment(data[i].GrnDate).format("YYYY-MM-DD")],
        grnNo : [data[i].GrnNo],
        invoiceTotal : [data[i].GrandTotal],
        balToPay : [data[i].BalToPay],
        accAmountPaid : [],
        amountPaid : [data[i].AmountPaid],
        select : [true], 
      }));
    }
    return paidInvoiceArray;
  }


  attachFileButtonClick(){
    this.fileUploadService.refNo = this.paymentForm.value.voucherNo;
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "75%";
     this.dialogService.openDialog(FileUploadComponent,dialogConfig);
        
    }

    attachReceiptFileButtonClick(item){
      this.fileUploadService.refNo = item.value.grnNo;
       const dialogConfig = new MatDialogConfig();
       dialogConfig.disableClose = true;
       dialogConfig.autoFocus = true;
       dialogConfig.width = "75%";
       this.dialogService.openDialog(FileUploadComponent,dialogConfig);
          
      }


    viewGRNById(){
      var hasGrnNo;
      var grnNo;  
      hasGrnNo=this.route.snapshot.queryParamMap.has('grnNo');
       
        if(hasGrnNo){
          grnNo = this.route.snapshot.queryParamMap.get('grnNo')
          this.newButtonClick();   
          this.purchaseInvoiceService.getAll()
          .subscribe(
             (data) => {
                        var unpaidInvoice = data.filter(obj =>{
                          return obj.GrnNo === grnNo &&
                          (obj.Status ==='Unpaid' || obj.Status ==='Partially paid');
                        });  
                        this.patchInvoiceValuesToForm(unpaidInvoice);  
                       },
            (err) => 
                     {
                       if(err instanceof HttpErrorResponse){                 
                         if(err.status == 401){
                           this.router.navigate(['/login']);
                         }
                       }
                       console.log(err);
                     });            
              
    }
  
  }
  
   
  patchInvoiceValuesToForm(data){   
    this.paymentForm.patchValue({  
      supId : data[0].SupId,
      supName : data[0].SupName,
      address : data[0].Address,
  
    });
    
    this.paymentForm.setControl('unpaidInvoices',this.loadUnpaidInvoices(data));

  }


  savePDF(action){

    const documentDefinition = { 
      pageSize: 'A4',
      pageOrientation: 'portrait',  
      pageMargins: [40, 40, 40, 120],
 
      content: [ 
          
        {
          columns : [ 
            
                  { image:this.logo,            
                    width: 100,
                    height: 100,
                  },

                [                                         
                 {
                  text: 'PAYMENT',
                  color: '#333333',
                  width: '*',
                  fontSize: 30,
                  bold: true,
                  alignment: 'right',
                  margin: [0, 0, 0, 15],
                },

                {
                 stack: [
                  {
                    columns: [
                      {
                        text: 'Payment No. :',
                        color: '#aaaaab',
                        bold: true,
                        width: '*',
                        fontSize: 12,
                        alignment: 'right',
                      },
                      {
                        text: this.paymentForm.value.voucherNo,
                        bold: true,
                        color: '#333333',
                        fontSize: 12,
                        alignment: 'right',
                        width: 115,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: 'Paid Date :',
                        color: '#aaaaab',
                        bold: true,
                        width: '*',
                        fontSize: 12,
                        alignment: 'right',
                      },
                      {
                        text: moment(this.paymentForm.value.paidDate).format("YYYY-MM-DD"),
                        bold: true,
                        color: '#333333',
                        fontSize: 12,
                        alignment: 'right',
                        width: 115,
                      },
                    ],
                  },

                ],
              },
            ],
          ],
        },              

        {
          columns : [
         
            [
              
              { text: 'Paid To :', margin: [0, 20, 0, 5], color: '#aaaaab',   fontSize: 12,},  
              { text: this.paymentForm.value.supName,margin: [0, 0, 0, 0], bold:true,   fontSize: 12, },  
              { text: this.paymentForm.value.address,margin: [0, 0, 0, 0] },  

            ],
            [
              { text: this.paymentForm.value.paymentType ? `Payment Type : ${this.paymentForm.value.paymentType}` :'' ,width: 'auto',   fontSize: 12,  margin: [15, 40, 0, 0]},
              { text: this.paymentForm.value.payRefNo ? `Payment Ref.No : ${this.paymentForm.value.payRefNo}` :'' ,width: 'auto',   fontSize: 12, margin: [15, 0, 0, 0] },

            ],

          ]

        },

        '\n\n',
                           
        {  
          layout: {
            defaultBorder: false,
            hLineWidth: function(i, node) {
              return 1;
            },
            vLineWidth: function(i, node) {
              return 1;
            },
            hLineColor: function(i, node) {
              if (i === 1 || i === 0) {
                return '#bfdde8';
              }
              return '#eaeaea';
            },
            vLineColor: function(i, node) {
              return '#eaeaea';
            },
            hLineStyle: function(i, node) {
              // if (i === 0 || i === node.table.body.length) {
              return null;
              //}
            },
            // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
            paddingLeft: function(i, node) {
              return 10;
            },
            paddingRight: function(i, node) {
              return 10;
            },
            paddingTop: function(i, node) {
              return 2;
            },
            paddingBottom: function(i, node) {
              return 2;
            },
            fillColor: function(rowIndex, node, columnIndex) {
              return '#fff';
            },
          },
          table: {  
             
              headerRows: 1,  
              widths: ['*', 'auto','auto','auto'],  
              body: [  
                [
                 { text: 'Invoice Date', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                 { text: 'Invoice No', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                 { text: 'Invoice Amount', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]},                  
                 { text: 'Paid Amount', style:'tableFont',fillColor: '#D2B4DE', border: [false, true, false, true],   margin: [0, 5, 0, 5]}],
                ...this.getUnpaidInvoices.value.map(p => ([{ text :p.grnDate, border: [false, false, false, true],  margin: [0, 5, 0, 5],style:'tableFont'},{ text :p.grnNo, border: [false, false, false, true],  margin: [0, 5, 0, 5],style:'tableFont'}, {text : this.transformNumberFormat(p.invoiceTotal), border: [false, false, false, true], margin: [0, 5, 0, 5], alignment: 'right',style:'tableFont' },{text : this.transformNumberFormat(p.amountPaid), border: [false, false, false, true], margin: [0, 5, 0, 5], alignment: 'right',style:'tableFont'}])),               
              ]           
        }       
      },

      '\n',
      '\n',
      {
        columns : [
                  {},
                       
              { 
                layout: {
                defaultBorder: false,
                hLineWidth: function(i, node) {
                  return 1;
                },
                vLineWidth: function(i, node) {
                  return 1;
                },
                hLineColor: function(i, node) {
                  return '#eaeaea';
                },
                vLineColor: function(i, node) {
                  return '#eaeaea';
                },
                hLineStyle: function(i, node) {
                  // if (i === 0 || i === node.table.body.length) {
                  return null;
                  //}
                },
                // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
                paddingLeft: function(i, node) {
                  return 10;
                },
                paddingRight: function(i, node) {
                  return 10;
                },
                paddingTop: function(i, node) {
                  return 3;
                },
                paddingBottom: function(i, node) {
                  return 3;
                },
                fillColor: function(rowIndex, node, columnIndex) {
                  return '#fff';
                },
              },
                width: 'auto', 
                fontSize: 12,            
                table: {
                headerRows: 1,
                widths: ['auto', 'auto'],
                    body: [
                    [
                      {
                        text: 'Paid Total',
                        bold: true,
                        alignment: 'right',
                        border: [false, false, false, true],
                        margin: [0, 5, 0, 5],
                      },
                      {
                        text: this.transformNumberFormat(this.paymentForm.value.paidTotal),
                        bold: true,          
                        alignment: 'right',
                        border: [false, false, false, true],
                        fillColor: '#f5f5f5',
                        margin: [0, 5, 0, 5],
                      },
                    ],
                  ],
                },
              },         
        ]

      },

      // '\n','\n','\n',  
      // '\n','\n',

  ],  // end content

  footer: ()=> {

    return [
    
      { margin: [40, 5, 40, 10],canvas: [{type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 } ]},
      {
        margin: [40, 5, 40, 20],
        columns : [
          [
            { text: 'Address',width: 'auto',bold: true, fontSize: 10},
            { text: this.companyData[0].CompanyName,width: 'auto',bold: true,fontSize: 10 },  
            { text: this.companyData[0].Address,width: 'auto', fontSize: 10 },   
          ],
          [
            
            { text: 'Contact Info',width: '*',bold: true, margin: [20, 0, 0, 0], fontSize: 10},
            { text: this.companyData[0].Phone,width: '*',margin: [20, 0, 0, 0], fontSize: 10 },  
            { text: this.companyData[0].MobileNo,width: '*',margin: [20, 0, 0, 0], fontSize: 10}, 
            { text: this.companyData[0].Email,width: '*',margin: [20, 0, 0, 0], fontSize: 10},
            { text: this.companyData[0].Web,width: '*',margin: [20, 0, 0, 0], fontSize: 10}    
  
          ],
  
          [
            
            { text: 'Bank Details',width: 'auto',bold: true, fontSize: 10},
            { text: 'Bank Name   - ',width: 'auto',fontSize: 10}, 
            { text: `Acc.Name    -`,width: 'auto',fontSize: 10},   
            { text: `Account No  - `,width: 'auto',fontSize: 10},   
            { text: `Branch Name - `,width: 'auto',fontSize: 10} 
  
          ],
  
        ]
      },
  
    ]
    
     },

  
  

 
      styles: {  
        reportHeader: {  
            bold: true,  
            decoration: 'underline',  
            fontSize: 14,  
            margin: [0, 15, 0, 15],
            alignment: 'center',             
        },
        tableFont: {  
          fontSize: 10,  
           
      
        }       
    } 
      
      
     };// end 


      if(action==='open'){    
            pdfMake.createPdf(documentDefinition).open();  
          
        }else if(action === 'print'){    
            pdfMake.createPdf(documentDefinition).print();          
        }
        else if(action === 'download'){    
          pdfMake.createPdf(documentDefinition).download(`Receipt-${this.paymentForm.value.receiptNo}`);     
      }


  }

  transformNumberFormat(number) {
    return this.decimalPipe.transform(number,'1.2-2');
   }







}//end class

